module.exports = __webpack_public_path__ + "img/reportes.c3e179aa.svg";